.uni-selection {
  display: inline-flex;
  padding: 10px;
  border-radius: 5px;
}

.uni-selection-background {
  background-color: #EEE;
}

.uni-selection-outlined {
  border: 1px dashed darkblue;
}
